<template>
  <div id="app" class="app-background">
    <b-navbar toggleable="lg" type="dark" v-if="notIsLoginPage">
      <b-navbar-brand href="#">Gestauto - Auto atendimento</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item :to="{ name: 'relato' }">Relatos</b-nav-item>
          <!-- Link para a página de criação de usuário -->
          <!--b-nav-item :to="{ name: 'createUser' }">Criar Usuário</b-nav-item-->
        </b-navbar-nav>

        <!-- Botão de logout alinhado à direita -->
        <b-button class="logout-button" variant="outline-light" @click="logout" id="logout-button" title="Sair">
          <i class="fas fa-sign-out-alt"></i>
        </b-button>
        <b-tooltip target="logout-button" triggers="hover focus">
          Sair
        </b-tooltip>
      </b-collapse>
    </b-navbar>
    <router-view/>
  </div>
</template>


<script>
  export default{
    computed:{
      notIsLoginPage(){
        return this.$route.name !== "login";
      }
    },
    methods: {
      logout() {
        // Aqui você deve implementar a lógica de logout
        // Por exemplo, remover tokens de autenticação
        localStorage.removeItem('token'); // ou qualquer que seja o seu método de autenticação

        // Redirecionar para a página de login
        this.$router.push({ name: 'login' });
      }
    }
  }
</script>

<style>
.navbar {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    background-color: #00b044;
    font-weight: bold;
}

.logout-button {
    margin-left: auto; /* Move o botão de logout para a direita */
}

.app-background {
  background-color: #f4f6f8;
  min-height: 100vh;
}
</style>
